import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource } from '@angular/material';
import { LaborService } from '../labor.service';
import { LabordialogComponent } from '../labordialog/labordialog.component';

@Component({
  selector: 'app-unverified-labor',
  templateUrl: './unverified-labor.component.html',
  styleUrls: ['./unverified-labor.component.css']
})
export class UnverifiedLaborComponent implements OnInit {

  unverifiedLabors = [];

  constructor(
    private dialogRef: MatDialogRef<UnverifiedLaborComponent>,
    private laborService: LaborService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.unverifiedLabors = data.unverifiedLabors;
      console.log(this.unverifiedLabors);
  }

  viewDetail(labor):void{
    console.log(labor);
    let dialogRef = this.dialog.open(LabordialogComponent, {
      disableClose: true,
      width: '40%',
      data: {
        mode: 'edit',
        labors: [],
        selectedLabor: labor,        
        currentVinNumber: ''
      }
    });
  }

  ngOnInit() {

  }

}
